/* eslint-disable no-unused-expressions */
export default `[id*='mail-editor-reference-message-container']:has(hr, [id*='divRplyFwdMsg'], div[style*='border-top'], blockquote) {
  display: none !important;
}

[id*='divRplyFwdMsg'] {
  display: none !important;
}

div[style*='border-top: solid #e1e1e1'],
div[style*='border-top: solid #b5c4df'],
div[style*='border-top:solid #E1E1E1'],
div[style*='border-top:solid #B5C4DF'],
div[style*='border-top: 1pt solid'],
div[style*='border-top:1pt solid'] {
  &:has(b) {
    display: none !important;

    & ~ * {
      display: none !important;
    }
  }
}

.gmail_quote,
[class*='gmail_quote'],
div[class*='gmail_extra'],
blockquote[class*='gmail_quote'],
blockquote {
  display: none !important;
}

blockquote[type='cite'],
blockquote[cite] {
  display: none !important;
}

[id*='yahoo_quoted'],
blockquote[class*='yahoo_quoted'] {
  display: none !important;
}

.text-content blockquote:not([class*='user-quote']) {
  display: none !important;
}
p { margin-top: 0; margin-bottom: 0; word-wrap: break-word;}
`;

export const basicEmailCss = `
p { margin-top: 0; margin-bottom: 0; word-wrap: break-word;}
.gmail_quote p,
[class*='gmail_quote'] p,
div[class*='gmail_extra'] p,
blockquote[class*='gmail_quote'] p,
blockquote p { margin-top: revert; margin-bottom: revert; }
`;
